import { updateSettings, onClose, open } from "./api";
export function enableFormSettings(_ref) {
  var email = _ref.email,
    applicationId = _ref.applicationId;
  updateSettings({
    contactForm: {
      suppress: false,
      attachments: false,
      fields: [{
        id: 'subject',
        prefill: {
          '*': 'Requirements Feedback'
        }
      }, {
        id: 'description'
      }, {
        id: 'email',
        prefill: {
          '*': email
        }
      },
      // Until we have a method of returning this ID from the BE, it will need to be hardcoded
      {
        id: 10195439259283,
        prefill: {
          '*': applicationId
        }
      },
      // Sandbox
      {
        id: 5281419404813,
        prefill: {
          '*': applicationId
        }
      } //Production
      ],
      ticketForms: []
    },
    contactOptions: {
      enabled: true,
      contactFormLabel: {
        '*': 'Requirements Feedback'
      },
      chatLabelOnline: {
        '*': 'Live Chat'
      }
    },
    launcher: {
      label: {
        '*': 'Help'
      },
      chatLabel: {
        '*': 'Help'
      }
    }
  });
}
export function disableFormSettings() {
  updateSettings({
    contactForm: {
      suppress: true
    },
    contactOptions: {
      enabled: false
    },
    launcher: {
      label: {
        '*': 'Help'
      },
      chatLabel: {
        '*': 'Live Chat'
      }
    }
  });
}
export function openFormDirectly() {
  updateSettings({
    chat: {
      suppress: true
    },
    contactForm: {
      suppress: false
    }
  });
  onClose(function () {
    updateSettings({
      chat: {
        suppress: false
      },
      contactForm: {
        suppress: false
      }
    });
    onClose();
  });
  open();
}